import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth/AuthService';
import {iClient} from '../Model/ClientModel';
import {IOffice} from '../Model/Office';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  constructor(private httpClient: HttpClient,
              private authService: AuthService,) { }

  getAllOffices(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}office`, params);
  }

  getOfficeDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}office`, params);
  }

  updateOffice(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.patientService}office`,body, params);
  }

  officeRegistration(body: IOffice): Observable<any> {
    return this.authService.post(`${environment.patientService}office`, body);
  }

  officeBulkUpload(data): Observable<any> {
    return this.authService.postD(`${environment.reportService}patientreport`, data);
  }

  deleteOffice(params?:any): Observable<any> {
    return this.authService.delete(`${environment.patientService}office`, params);
  }

  getOfficeTemplate(params): Observable<Blob> {
    return this.authService.getPDFView(`${environment.reportService}patientreport`, params, 'blob');
  }


  /*updateOfficeRuleRegistration(body:any,params:any): Observable<any> {
    return this.authService.put(`${environment.batchJob}office-wo-rules`, body,params);
  }*/
  officeRulesRegistration(body:any): Observable<any> {
    return this.authService.post(`${environment.batchJob}office-wo-rules`, body);
  }
  getOfficeRulesDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.batchJob}office-wo-rules`, params);
  }
  officeMultipleOfficeRulesRegistration(body:any,params:any): Observable<any> {
    return this.authService.postP(`${environment.batchJob}office-wo-rules`, body,params);
  }
}
